import React from 'react';

export default (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path d="M24 0H0V24H24V0Z" fill="white" fillOpacity="0.01" />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12 2.40426C6.70042 2.40426 2.40426 6.70042 2.40426 12C2.40426 17.2996 6.70042 21.5957 12 21.5957C17.2996 21.5957 21.5957 17.2996 21.5957 12C21.5957 6.70042 17.2996 2.40426 12 2.40426ZM1 12C1 5.92487 5.92487 1 12 1C18.0751 1 23 5.92487 23 12C23 18.0751 18.0751 23 12 23C5.92487 23 1 18.0751 1 12ZM15.305 8.69501C15.5792 8.96921 15.5792 9.41377 15.305 9.68797L12.993 12L15.305 14.312C15.5792 14.5862 15.5792 15.0308 15.305 15.305C15.0308 15.5792 14.5862 15.5792 14.312 15.305L12 12.993L9.68797 15.305C9.41377 15.5792 8.96921 15.5792 8.69501 15.305C8.42081 15.0308 8.42081 14.5862 8.69501 14.312L11.007 12L8.69501 9.68797C8.42081 9.41377 8.42081 8.96921 8.69501 8.69501C8.96921 8.42081 9.41377 8.42081 9.68797 8.69501L12 11.007L14.312 8.69501C14.5862 8.42081 15.0308 8.42081 15.305 8.69501Z"
      fill="currentColor"
    />
  </svg>
);
